import styled from 'styled-components';
import {ByocOnboardingContainer} from '../styles';

export const PaymentDetailsContainer = styled(ByocOnboardingContainer)`
  display: flex;
  flex-direction: column;
  min-height: 600px;
  width: 90%;
  max-width: 900px;

  @media (max-width: 970px) {
    width: 100%;
  }
`;

export const StripeCheckoutContainer = styled.div`
  width: 100%;
  margin-top: 24px;
  flex: 1;
  min-height: 500px;

  @media (max-width: 767px) {
    min-height: 400px;
  }
`;
